import React from 'react';

import { usePrivacyPolicy } from '../../hooks/usePrivacyPolicy';

import { PolicyDocumentsForm } from './PolicyDocumentsForm';

export const PrivacyPolicyView = () => {
    const { isLoading, error, ...privacyPolicy } = usePrivacyPolicy();

    if (isLoading) {
        return (
            <div className="tw-flex tw-justify-center tw-py-48">
                <div className="tw-animate-spin tw-h-24 tw-w-24 tw-border-2 tw-border-primary tw-border-t-transparent tw-rounded-full" />
            </div>
        );
    }

    return (
        <PolicyDocumentsForm
            {...privacyPolicy}
            error={error ? <p className="tw-text-s tw-text-danger tw-m-0">{error}</p> : null}
        />
    );
};
